import {computed, ref, unref} from 'vue';
import api from "@/api/methods";

export function getConstructionUsers(constructionList = [], constructionUnit = '') {
    if (!constructionUnit) {
        return [];
    }
    let info = constructionList.find(a => a.id == constructionUnit);
    if (info) {
        return info.users || [];
    }
    return [];
}

export async function fetchConstructionData() {
    let constructionList = [];
    let constructionInfo = {};
    let res = await api.contract.GetConstruction();
    if (res.data?.data) {
        constructionList = res.data.data.construction || [];
        let user_info = res.data.data.user_info || {};
        let user_list = res.data.data.construction_users || [];
        constructionList.forEach(item => {
            item.users = user_list.filter(a => a.construction_id == item.id).map(a => {
                return user_info[a.userid] || {};
            });
        });
        constructionInfo = res.data.data;
    }
    return {
        constructionList,
        constructionInfo,
    };
}

export function useConstruction(ruleFormRef) {
    const constructionList = ref([]);
    const constructionInfo = ref({});
    const fuzeUsers = computed(() => {
        let ruleForm = ruleFormRef ? unref(ruleFormRef) : null;
        return getConstructionUsers(constructionList.value, ruleForm?.construction_unit);
    });

    async function getConstruction() {
        constructionList.value = [];
        constructionInfo.value = {};
        let {constructionList: list, constructionInfo: info} = await fetchConstructionData();
        constructionList.value = list;
        constructionInfo.value = info;
    }

    return {
        constructionList,
        constructionInfo,
        fuzeUsers,
        getConstruction,
    };
}
